// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$courseApiService = {
      course_api_url: `${process.env.VUE_APP_COURSE_API_URL}/courses`,

      /**
       * 查詢星期幾持續進行的課程
       * @param {number} day_of_week - 星期幾
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryContinuedOnDayOfWeek(day_of_week, additional = '') {
        day_of_week = day_of_week == 0 ? 7 : day_of_week
        const url = `${this.course_api_url}?filter[continued]&filter[week]=${day_of_week}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 查詢星期幾有直播的課程
       * @param {number} day_of_week - 星期幾
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryHaveLiveStreamOnDayOfWeek(day_of_week, additional = '') {
        day_of_week = day_of_week == 0 ? 7 : day_of_week
        const url = `${this.course_api_url}?filter[continued]&filter[have_live_stream]&filter[week]=${day_of_week}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得最近開始的課程
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getStartedRecently(additional = '') {
        const url = `${this.course_api_url}/started-recently`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得持續進行的課程
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getContinued(additional = '') {
        const url = `${this.course_api_url}?filter[continued]`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 查詢有直播的課程
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getHaveLiveStream(additional = '') {
        const url = `${this.course_api_url}?filter[continued]&filter[have_live_stream]`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 查詢最近提供回顧的課程
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getRecentlyProvidesReview(additional = '') {
        const url = `${this.course_api_url}/recently-provided-review`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過 ID 取得課程
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.course_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
